import Headroom from 'headroom.js';
// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import Device from '../util/Device';
import innerHeight from 'ios-inner-height';

export default new class {

  init () {
    let headroom = new Headroom(document.getElementById('site-header'), {
      offset: 75,
    })
    headroom.init();
    this.isMobileOpen = false
    this.bindMobile()
  }

  bindMobile () {
    this.$primaryWrap = $('#navWrap')
    $('#mobileOpen').on('click', () => {
      if (this.isMobileOpen) {
        this.closeMobile()
        return
      }
      this.openMobile()
    })
    $('.js-close-nav').on('click', () => {
      this.closeMobile()
    })
    Device.registerCallbacks((name) => {
      // On width change, we simply collapse mobile nav
      if (name !== 'width') {
        return
      }
      this.closeMobile()
    })
    // Helps account for ios collapsible footer nav
    let currentInnerHeight = null
    setInterval(() => {
      if (currentInnerHeight === innerHeight()) {
        return
      }
      currentInnerHeight = innerHeight()
      this.$primaryWrap.css({
        'maxHeight': `${currentInnerHeight}px`,
      })
    }, 100);
  }

  openMobile () {
    this.$primaryWrap.addClass('is-open')
    this.buildOverlay()
    this.isMobileOpen = true
  }

  closeMobile () {
    this.$primaryWrap.removeClass('is-open')
    this.closeOverlay()
    this.isMobileOpen = false
  }

  buildOverlay () {
    this.$overlay = $('<div class="fixed inset-0 z-30 opacity-75 bg-white"></div>')
    this.$overlay.appendTo('body')
    $('body').css({
      'position': 'fixed',
      'overflow': 'hidden',
      'height': '100vh',
    })
    this.$overlay.on('click', () => {
      this.closeMobile()
    })
  }

  closeOverlay () {
    $('body').css({
      'position': '',
      'overflow': '',
      'height': '',
    })
    if (!this.$overlay) {
      return
    }
    this.$overlay.off('click')
    this.$overlay.remove()
    this.$overlay = null
  }

}



// WEBPACK FOOTER //
// ./scripts/components/header.js